import { FormGroup, FormLabel } from "react-bootstrap";
import Select from "react-select";

/**
 * @deprecated Use `Select` from `fields` folder instead
 */
const SelectField = ({ label, value, onChange, options, ...props }) => {
  const optionValue = options?.find((option) => option.value === value);
  return (
    <FormGroup>
      {label && <FormLabel className="fs-standard">{label}</FormLabel>}
      <Select
        classNamePrefix="select-input"
        onChange={(option) => onChange(option?.value ?? null)}
        options={options}
        value={optionValue}
        maxMenuHeight={600}
        styles={{
          multiValue: (base) => ({
            ...base,
            backgroundColor: props.disabled ? "#eeeeee" : "#ffffff",
            color: "black",
          }),
          option: (styles, { isDisabled }) => {
            return {
              ...styles,
              color: isDisabled ? "SlateGray" : "black",
              cursor: isDisabled ? "not-allowed" : "default",
              fontWeight: isDisabled ? 600 : "default",
            };
          },
          control: (base) => ({
            ...base,
            "min-height": props.contained ? "100px" : "auto",
            "max-height": props.contained ? "300px" : "auto",
            "overflow-y": props.contained ? "auto" : "inherit",
          }),
        }}
        {...props}
      />
    </FormGroup>
  );
};

export default SelectField;
